import JSZip from "jszip";

interface ZipFile {
  name: string;
  content: string | Blob | ArrayBuffer;
}

interface DownloadZipParams {
  zipName: string;
  files: ZipFile[];
}

export const downloadZip = async ({ zipName, files }: DownloadZipParams) => {
  try {
    const zip = new JSZip();

    files.forEach(file => {
      zip.file(file.name, file.content);
    });

    const zipBlob = await zip.generateAsync({ type: "blob" });

    const url = window.URL.createObjectURL(zipBlob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${zipName}.zip`;

    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error downloading ZIP:", error);
    throw error;
  }
};

export const downloadFile = ({ blob, filename }: { blob: Blob; filename: string; }) => {
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;

  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};
